exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".g-pc-click[data-v-5c6655ea]{margin:18px 0;border-bottom:1px solid #ccc}.sort[data-v-5c6655ea]{float:right}.clear[data-v-5c6655ea]{clear:both}", ""]);

// exports
